import CenteredHero from "@/components/CenteredHero"
import GeneralLayout from "@/layouts/General"
import { wwbList } from "@/app/utils/constants"
import Content01 from "@/assets/imgs/our-story/wwb/content01.jpg"
import Content02 from "@/assets/imgs/our-story/wwb/content02.jpg"
import Content03 from "@/assets/imgs/our-story/wwb/plates.jpeg"
import Content04 from "@/assets/imgs/our-story/wwb/candle.jpeg"
import Content05 from "@/assets/imgs/our-story/wwb/content03.jpeg"
import ImageSkeleton from "@/components/skeletons/ImageSkeleton"

const WWB = () => {
  return (
    <>
      <GeneralLayout bgColor="bg-white" isFixed={false}>
        <CenteredHero title="What We Believe" custParagraphFont="font-americanTC" paragraph="As our parents have raised us with love and compassion, it is now our turn to continue to spread the love they have showered on us throughout our life and to pay it forward." custCls="bg-[url('/src/assets/imgs/our-story/wwb/wwb-hero.jpg')] h-[50vh]" />
        <div className="md:flex items-end px-12 py-12">
          <div className="w-full md:w-[35%]">
            <ImageSkeleton src={Content01} isDarker custCls="w-full object-cover object-center" custH="h-[250px] md:h-[288px] lg:h-[278px]" />
          </div>
          <div className="w-full md:w-[30%] max-md:pt-8 max-md:pb-12 text-center px-8 lg:mb-5">
            <span className="uppercase text-black text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-agcasmlt font-light"><span className="capitalize block text-charcoal-black text-lg sm:text-xl lg:text-2xl font-aAccSign">what</span>we believe</span>
            <div className="max-sm:leading-[10px] sm:leading-[14px] lg:leading-4 text-[10px] sm:text-sm lg:text-base font-americanTC tracking-wide text-[#6b5327] mt-3 md:mt-6 mb-8 md:mb-11">In faith, hope and love, while always aware
              that the greatest one of all is LOVE</div>
            <a href="#whatWeBelieveContent" className="bg-[#b79858] font-agcasmlt font-light text-charcoal-black text-sm sm:text-xl pt-2 pb-1 px-8">Load More</a>
          </div>
          <div className="w-full md:w-[35%]">
            <ImageSkeleton src={Content02} isDarker custCls="w-full object-cover object-center" custH="h-[250px] md:h-[288px] lg:h-[278px]" />
          </div>
        </div>
        <section id="whatWeBelieveContent" className="mt-5">
          <div className="bg-[#e5e3db] px-10 sm:px-16 lg:px-20">
            <div className="relative -top-10 px-2 sm:px-8 lg:px-12 pt-12 pb-12 bg-[url('/src/assets/imgs/our-story/wwb/section-cover.webp')] bg-cover bg-center no-repeat">
              <span className="uppercase text-black text-4xl font-agcasmlt font-light mb-5 inline-block">what we believe:</span>
              <div className="px-6 sm:px-10 lg:px-14">
                <ul className="list-disc">
                  {wwbList.map((w, i) => (
                    <li key={i} className="text-lg leading-6 font-americanTC tracking-wide">{w}</li>
                  ))}
                </ul>
              </div>
            </div>
            <div className="pb-12">
              <div className="md:flex items-end">
                <div className="w-full">
                  <ImageSkeleton src={Content03} isDarker custCls="w-full object-cover object-bottom" custH="max-h-[200px] md:max-h-[300px] lg:max-h-[400px]" />
                </div>
                <div className="w-full">
                  <ImageSkeleton src={Content04} isDarker custCls="w-full object-cover object-bottom" custH="max-h-[200px] md:max-h-[300px] lg:max-h-[400px]" />
                </div>
              </div>
              <ImageSkeleton src={Content05} isDarker custCls="w-full object-cover object-bottom" />
            </div>
          </div>
          <div className="bg-[url('/src/assets/imgs/di-sana/slide-02.jpg')] h-[90vh] w-full bg-cover bg-center"></div>
        </section>
        <footer className="">
          <div className="py-5 text-center">
            <h1 className="text-[#b79858] font-light text-2xl sm:text-3xl md:text-4xl lg:text-5xl"><span className="uppercase font-agcasmlt">di sini di sana</span><span className="font-sloopScriptPro block text-base sm:text-xl">by Rachman & Sons</span></h1>
          </div>
        </footer>
      </GeneralLayout>
    </>
  )
}

export default WWB